import { DollarSign, Package, RefreshCw, Mail, Clock } from "lucide-react";
import { money } from "@/lib/adminApi";

export default function AdminStats({ summary }) {
  if (!summary) return null;
  const cards = [
    { id: "revenue", label: "Revenue", value: money(summary.revenue_cents), icon: <DollarSign size={18} /> },
    { id: "orders", label: "Paid Orders", value: summary.paid_orders, icon: <Package size={18} /> },
    { id: "subs", label: "Active Subscriptions", value: summary.active_subscriptions, icon: <RefreshCw size={18} /> },
    { id: "signups", label: "Email Signups", value: summary.email_signups, icon: <Mail size={18} /> },
    { id: "pending", label: "Pending Checkouts", value: summary.pending_orders, icon: <Clock size={18} /> },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-8" data-testid="admin-stats">
      {cards.map((c) => (
        <div key={c.id} className="bg-white rounded-xl border border-gold/15 p-4" data-testid={`admin-stat-${c.id}`}>
          <div className="flex items-center justify-between text-gold mb-2">
            <span className="text-[11px] uppercase tracking-widest text-gray-400">{c.label}</span>{c.icon}
          </div>
          <p className="font-playfair text-2xl font-bold text-brown-dark">{c.value}</p>
        </div>
      ))}
    </div>
  );
}
